import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Bus Basic Service
 * Temel otobüs API'leri için servis
 */
export const busBasicService = {
  /**
   * Sayfa tipini belirle
   * @param {Array} queries - URL segment'leri (örn: ["istanbul-ankara", "2025-10-18"])
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Usage Examples:
   * decidePageType(["istanbul-ankara", "2025-10-18"]) 
   * → GET /decidePageType?query=istanbul-ankara&query=2025-10-18
   */
  decidePageType: (queries = [], locale = "tr", headers = {}, hasErrorHandler = false) => {
    const queryString = queries.map(q => `query=${encodeURIComponent(q)}`).join('&');
    return request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.bus.basic.decidePageType}?languagecode=${locale}&${queryString}`,
      payload: {},
      headers,
      hasErrorHandler,
    });
  },

  /**
   * Tüm kampanyaları getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr"
   * }
   */
  getAllCampaigns: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.basic.getAllCampaigns,
      payload,
      headers,
      hasErrorHandler,
    }),

    /**
   * offers list campaign
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr"
   * }
   */
  getListCampaigns: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.basic.getListCampaigns,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Tüm ayrıcalıkları getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr"
   * }
   */
  getAllPrivileges: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.basic.getAllPrivileges,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Blog yazılarını getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.ClientChannel - İstemci kanalı (örn: "web", "mobile")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "ClientChannel": "web"
   * }
   */
  getBlog: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.basic.getBlog,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Sık sorulan soruları getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CurrencyCode": "TRY"
   * }
   */
  getSss: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.basic.getSss,
      payload,
      headers,
      hasErrorHandler,
    }),
};
